import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { GeneralHistoryViewModel } from 'src/app/model/general/history.view';
import { historyActions } from 'src/app/store/history/history.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HistoryPersonalService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  getPersonId = (): Observable<number> =>
    this.store.select('history', 'personId');

  getHistories = (): Observable<GeneralHistoryViewModel[]> =>
    this.store.select('history', 'personalHistories');

  isSaving = (): Observable<boolean> => this.store.select('history', 'saving');

  loadHistories = (personId: number): Observable<GeneralHistoryViewModel[]> =>
    this.rest
      .get({
        url: `${environment.endpoints.history}/personal/{personId}`,
        urlParams: { personId },
      })
      .pipe(tap(this.setPersonalHistories));

  save = (
    histories: GeneralHistoryViewModel[],
    hasComplete: boolean
  ): Observable<GeneralHistoryViewModel[]> =>
    this.rest
      .post({
        url: `${environment.endpoints.history}/personal`,
        body: histories,
      })
      .pipe(tap(() => this.addToSaved(hasComplete)));

  setPersonalHistories = (personalHistories: GeneralHistoryViewModel[]) =>
    this.store.dispatch(
      historyActions.setPersonalHistoriesAction({ personalHistories })
    );

  addToSaved = (hasComplete: boolean, value: number = 1) =>
    this.store.dispatch(
      historyActions.addToSavedAction({ value, hasComplete })
    );
}
